import { render } from "./InstallationInfo.vue?vue&type=template&id=51752312&ts=true"
import script from "./InstallationInfo.vue?vue&type=script&lang=ts"
export * from "./InstallationInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__